<div
  class="authentication-field-2 tw-flex tw-items-center tw-relative tw-max-w-full tw-my-0"
  (keydown.tab)="$event.stopPropagation()"
  (keydown.shift.tab)="$event.stopPropagation()"
  (click)="$event.stopPropagation()"
>
  <div
    [class.authentication-content-logged-new]="isLoggedIn"
    class="authentication-content tw-flex tw-flex-col tw-justify-center tw-items-stretch tw-flex-1"
  >
    @if (isAuthLoading()) {
      <app-skeleton-loader-plus2 [skeletonType]="skeletonTypes.AUTH_FIELD"></app-skeleton-loader-plus2>
    } @else if (!isLoggedIn || loginWithGuest) {
      <div class="custom-button tw-flex tw-flex-row-reverse tw-justify-around tw-items-center">
        @if (!loginWithGuest) {
          <button
            mat-flat-button
            data-testid="header.login.button"
            class="af__login_button mat-button-outline"
            [class.mat-button-text]="!buttonsHide"
            [disabled]="isOpeningLogin()"
            (pointerdown)="preloadLoginDialog()"
            (mouseenter)="preloadLoginDialog()"
            (focus)="preloadLoginDialog()"
            (click)="openLoginDialog()"
          >
            @if (isOpeningLogin()) {
              <mat-spinner diameter="16"></mat-spinner>
            } @else {
              {{ buttonsHide ? ('GENERAL.SIGN_IN' | translate) : '' }}
            }
          </button>
        }
        <span class="vertical-line"></span>
        @if (isEnableRegistration && buttonsHide && !isEnableGuestPlayers) {
          <div class="register-container tw-relative">
            <span class="pix-tag"><img src="assets/images/pixtag.svg" alt="PIX" /> PIX</span>
            <button
              id="register-button"
              mat-flat-button
              class="mat-button-theme-color af__register_button tw-relative tw-flex tw-items-center tw-justify-center"
              [disabled]="isOpeningRegister()"
              (pointerdown)="preloadRegisterDialog()"
              (mouseenter)="preloadRegisterDialog()"
              (focus)="preloadRegisterDialog()"
              (click)="openRegister(true)"
            >
              @if (isOpeningRegister()) {
                <span class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
                  <mat-spinner diameter="16"></mat-spinner>
                </span>
              }
              <span [style.visibility]="isOpeningRegister() ? 'hidden' : 'visible'">{{ 'GENERAL.REGISTER_2' | translate }}</span>
            </button>
          </div>
        }
        @if (!isLoggedIn && isEnableGuestPlayers) {
          <div class="tw-flex tw-flex-col tw-h-full">
            <div class="menu-right tw-w-full">
              @if (!isLoggedIn) {
                <div
                  [class.spinner]="openingGuestDeposit"
                  [class.disabled]="openingGuestDeposit"
                  (click)="navigateToGuestDeposit()"
                  class="guest-user-buttom tw-flex tw-flex-col tw-justify-evenly tw-items-center"
                >
                  <div class="new-user-label">{{ 'GUEST_USER.NEW_GUEST_TITLE' | translate }}</div>
                  <div class="title">
                    <span>{{ 'GUEST_USER.TITLE' | translate }}</span>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    } @else if (isLoggedIn) {
      <div
        class="auth-container tw-flex tw-justify-center tw-items-center tw-relative"
        [matMenuTriggerFor]="login"
        (menuOpened)="toggleMenuClassOpened()"
        (menuClosed)="toggleMenuClassOpened()"
      >
        <div
          data-testid="navbar.logged-in.indicator"
          class="deposit-section af__deposit_button_container tw-flex tw-flex-col tw-items-center tw-justify-center tw-relative"
        >
          @if (isEnableRegistration && hasDepositCreate && !hasPanelPermission) {
            <span class="pix-tag"><img src="assets/images/pixtag.svg" alt="PIX" /> PIX</span>
            <div
              data-testid="navbar.deposit.button"
              (click)="openLoginDialogDeposit(); $event.stopPropagation()"
              [class.disabled]="isOpeningDeposit()"
              class="deposit-button deposit_button_themed tw-relative tw-border-0 tw-text-xs tw-font-bold tw-flex tw-flex-row tw-items-center tw-justify-center tw-cursor-pointer tw-rounded tw-gap-1"
            >
              @if (isOpeningDeposit()) {
                <mat-spinner class="deposit-spinner" diameter="16" [style.color]="'currentColor'"></mat-spinner>
              } @else {
                <span>
                  {{ 'GENERAL.DEPOSIT_2' | translate }}
                </span>
              }
            </div>
          }
          @if (isGuestPlayer) {
            <span class="guest-tag tw-uppercase">{{ userFirstName }}</span>
          }
        </div>

        @if (isEnableRegistration && hasDepositCreateCompany && !hasPanelPermission) {
          <div class="separator tw-block"></div>
        }

        <div class="user-details tw-flex tw-flex-col tw-justify-center tw-items-start tw-cursor-pointer">
          <div class="user-row tw-flex tw-flex-row">
            <span class="username-text">
              {{ smarticoDisplayName }}
            </span>
          </div>
          <div class="balance-row tw-flex tw-flex-row tw-items-center tw-justify-start">
            <span class="balance-text">
              {{
                userBalanceWithBonus | currencycase: { hidden: hasCasinoGameOpened || UtilsService.valuesHidden, truncateFrom: 10000000 }
              }}
            </span>
          </div>
        </div>

        <div class="avatar-section tw-relative tw-flex tw-items-center tw-cursor-pointer">
          @if (isAvatarLoading) {
            <app-skeleton-loader-plus2 [skeletonType]="skeletonTypes.AUTH_FIELD_AVATAR"></app-skeleton-loader-plus2>
          } @else if (isSmarticoEnabled && profile?.avatar_id) {
            <div class="avatar-wrapper tw-relative tw-inline-block">
              <div class="level-progress-container tw-relative tw-flex tw-items-center tw-justify-center">
                <svg class="progress-ring" width="36" height="36" viewBox="0 0 36 36">
                  <defs>
                    <filter id="progress-glow" x="-50%" y="-50%" width="200%" height="200%">
                      <feGaussianBlur in="SourceAlpha" stdDeviation="2" />
                      <feOffset dx="0" dy="0" result="offsetblur" />
                      <feFlood flood-color="#F6921E" />
                      <feComposite in2="offsetblur" operator="in" />
                      <feMerge>
                        <feMergeNode />
                        <feMergeNode in="SourceGraphic" />
                      </feMerge>
                    </filter>
                  </defs>
                  <circle
                    class="progress-ring__circle"
                    stroke="#F6921E"
                    stroke-width="2"
                    fill="transparent"
                    r="16"
                    cx="18"
                    cy="18"
                    filter="url(#progress-glow)"
                    [style.stroke-dasharray]="100.5"
                    [style.stroke-dashoffset]="100.5 - (100.5 * progressPercentage) / 100"
                  />
                </svg>
                <div class="avatar-inner tw-overflow-hidden tw-flex tw-items-center tw-justify-center">
                  <img [src]="getAvatarUrl(profile.avatar_id)" class="avatar-img" />
                </div>
              </div>

              @if ((profile?.core_inbox_unread_count || 0) > 0) {
                <div class="notification-badge tw-flex tw-flex-col tw-justify-center tw-items-center tw-absolute">
                  <span>{{ (profile?.core_inbox_unread_count || 0) > 99 ? '99+' : profile?.core_inbox_unread_count || 0 }}</span>
                </div>
              }
            </div>
          } @else {
            <mat-icon class="icon_20">account_circle</mat-icon>
          }
        </div>
      </div>
    }
  </div>
</div>
<mat-menu #login="matMenu" class="left-menu scrollbar_hidden" xPosition="before" yPosition="below">
  @defer (on viewport) {
    <app-authentication-info
      #authenticationInfoComponent
      (click)="$event.stopPropagation()"
      (keydown.tab)="$event.stopPropagation()"
      (keydown.shift.tab)="$event.stopPropagation()"
      (toggleLoginSideMenuEvent)="trigger.closeMenu()"
      (updatedUser)="updateUserBalance()"
      [authFieldComponent]="this"
    ></app-authentication-info>
  } @loading {
    <app-skeleton-loader-plus2 [skeletonType]="skeletonTypes.AUTH_INFO"></app-skeleton-loader-plus2>
  } @placeholder {
    <span></span>
  }
</mat-menu>

<app-gamification-notifications></app-gamification-notifications>
